import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import RadioButtonCheckedRoundedIcon from '@mui/icons-material/RadioButtonCheckedRounded';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const CheckoutStepper = ({cartItems}) => {
    const [activeStep, setActiveStep] = useState('')
    const location = useLocation();
      console.log('location', location?.pathname)

      useEffect(() => {
        if (location?.pathname === '/cart') {
          setActiveStep(0);
        } else if (location?.pathname === '/checkout/address') {
          setActiveStep(1);
        } else if (location?.pathname === '/checkout/payment') {
          setActiveStep(2);
        }
      }, [location?.pathname]);

  return (
    <section className="w-full mx-auto bg-white py-2 max-sm:mt-4 lg:p-4 mb-2 flex items-center justify-center ">
        {/* <div className="flex items-center absolute top-6 left-4">
          <ArrowBack />
          {cartItems && location?.pathname === '/cart' && <div>
          <span className="ml-2">Cart Items</span> 
          (<span>{cartItems?.length}</span>)
          </div>}
        </div> */}
        <div className="flex-1 sm:pt-4">
          <div className="flex items-center justify-center gap-2 py-0 text-sm max-sm:text-xs">
            {/* Step 1: Cart */}
            <div className="flex w-10 flex-col items-center gap-1">
              {activeStep >= 0 ? (
                <CheckCircleRoundedIcon className="text-green-500" />
              ) : (
                <RadioButtonCheckedRoundedIcon className="text-gray-500" />
              )}
              <span
                className={activeStep === 0 ? " text-black" : "text-gray-500"}
              >
                Cart
              </span>
            </div>
            {/* Step 2: Address */}
            <div
              className={`h-[2px] max-xs:w-12 sm:w-32 lg:w-40 max-sm:w-20 -mt-6 rounded-full ${
                activeStep === 1 || activeStep === 2
                  ? "bg-green-500"
                  : "bg-gray-300"
              }`}
            />{" "}
            {/* Horizontal line between steps */}
            <div className="flex w-10 flex-col items-center gap-1">
              {activeStep >= 1 ? (
                <CheckCircleRoundedIcon className="text-green-500" />
              ) : (
                <RadioButtonCheckedRoundedIcon className="text-gray-500" />
              )}
              <span
                className={activeStep === 1 ? " text-black" : "text-gray-500"}
              >
                Address
              </span>
            </div>
            {/* Step 3: Payment */}
            <div
              className={`h-[2px] max-xs:w-12 sm:w-32 lg:w-40 max-sm:w-20 -mt-6 rounded-full ${
                activeStep === 2 ? "bg-green-500" : "bg-gray-300"
              }`}
            />{" "}
            {/* Horizontal line between steps */}
            <div className="flex w-10 flex-col items-center gap-1">
              {activeStep >= 2 ? (
                <CheckCircleRoundedIcon className="text-green-500" />
              ) : (
                <RadioButtonCheckedRoundedIcon className="text-gray-500" />
              )}
              <span
                className={activeStep === 2 ? " text-black" : "text-gray-500"}
              >
                Payment
              </span>
            </div>
          </div>
        </div>
      </section>
  )
}

export default CheckoutStepper